import { useState } from 'react'
import { Button } from 'semantic-ui-react'

import MakePicker from './MakePicker'
import ModelPicker from './ModelPicker'
import YearPicker from './YearPicker'

const Add = ({ onSave, onCancel }) => {
  const [state, setState] = useState({
    make: null,
    model: null,
    year: null,
  })

  return (
    <>
      <MakePicker
        value={state.make}
        onChange={(evt, data) => {
          setState({
            ...state,
            make: data.value,
          })
        }}
      />
      <ModelPicker
        make={state.make}
        model={state.model}
        onChange={(evt, data) => {
          setState({
            ...state,
            model: data.value,
          })
        }}
      />
      <YearPicker
        value={state.year}
        onChange={(evt, data) => {
          setState({
            ...state,
            year: data.value,
          })
        }}
      />
      <Button
        size="large"
        primary
        onClick={() => onSave(state)}
        disabled={!state.model || !state.make || !state.year}
      >
        Save
      </Button>
      <Button size="large" onClick={onCancel}>
        Cancel
      </Button>
    </>
  )
}

export default Add
